import styled from 'styled-components';
import Button from '../button/Button';
import Disclaimer from '../disclaimer/Disclaimer';
import StatusIndicator from '../status-indicator/StatusIndicator';
import Tooltip from '../tooltip/Tooltip';
export const BoxWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 100%;

  ${({ theme }) => theme.media.tabletL `
    flex-direction: row;
    justify-content: space-between;

  `};
`;
export const ContentWrapper = styled.div `
  position: relative;

  padding: 2.2rem 1.6rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.default};

  box-shadow: ${({ theme }) => theme.shadows.sm};

  ${({ theme }) => theme.media.tabletL `
    padding: 2.8rem 2rem 2.1rem;
  `};
`;
export const LoanStatusContainer = styled.div `
  width: 100%;

  padding: 5rem 1.6rem 2.3rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background: ${({ theme }) => theme.colors.surface.gradient};

  ${({ theme }) => theme.media.tabletL `
    padding: 2.3rem;
  `};
`;
export const CustomMarginState = styled(StatusIndicator) `
  top: -3.2rem;
  right: 0;

  padding-bottom: 1rem;

  ${({ theme }) => theme.media.tabletL `
    top: -4.2rem;
    padding-bottom: 2rem;
  `};
`;
export const MobileDisclaimer = styled(Disclaimer) `
  margin-bottom: 1.1rem;

  ${({ theme }) => theme.media.tabletL `
    display: none;
  `};
`;
export const RepaymentButton = styled(Button) `
  margin-top: 1.8rem;

  ${({ theme }) => theme.media.tabletL `
    margin-top: 2.1rem;
  `};
`;
export const BoxContentWrapper = styled.div `
  display: flex;
  align-items: center;

  padding: 1.2rem 1.4rem 1.7rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;
export const BoxContent = styled.div `
  display: flex;
  flex-direction: column;

  width: calc((100% - 0.1rem) / 2);
`;
export const BoxIconWrapper = styled.div `
  margin-right: 1.2rem;
`;
export const BoxMainContentWrapper = styled.div `
  display: flex;
  align-items: center;

  padding: 0rem 1.2rem;
  margin-bottom: 1.9rem;

  ${({ theme }) => theme.media.tabletL `
    margin-bottom: 3rem;
  `};
`;
export const Line = styled.div `
  width: 0.1rem;
  height: 4.2rem;

  margin: 0 1.6rem;

  background-color: ${({ theme }) => theme.colors.borders.default};
`;
export const LoanStatusBoxWrapper = styled.div `
  display: flex;
  flex-direction: column;

  width: 100%;

  padding: 2.2rem 1.2rem 2.2rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border: 1px solid ${({ theme }) => theme.colors.surface.disabled};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  word-break: break-word;

  &:last-child {
    margin-top: 1.2rem;
  }

  ${({ theme }) => theme.media.tabletL `

    padding: 2.4rem 1.2rem 2.1rem;
    
    &:last-child {
      margin-top: 0;
      margin-left: 1.2rem;
    }
  `};
`;
export const MainContentText = styled.div `
  display: flex;
  flex-direction: column;
`;
export const BoxHeader = styled.div `
  display: flex;
  align-items: center;
  position: relative;
`;
export const CustomTooltip = styled(Tooltip) `
  margin-left: 0.6rem;
  .tooltipbox {
    left: -6.2rem;
    width: 14rem;
  }
  ${({ theme }) => theme.media.tablet `
    .tooltipbox {
      left: -6.2rem;
      width: 14rem;
    }
    margin-left: 0.6rem;
  `}
`;
//# sourceMappingURL=styles.js.map